module.exports = __webpack_public_path__ + "static/img/chuzhonghuaxue.d5ea39f4.jpg";